/*
 Module for querying the wikidata api
 
 */
export function test() {
    console.log("!!!");
}
export function hey() {
    return 10;
}
//# sourceMappingURL=query.js.map